import type { LucideIcon } from 'lucide-react'

type BadgeIconProps = {
  MainIcon: LucideIcon
  BadgeIcon: LucideIcon
  mainSize?: number
  badgeSize?: number
  badgeStrokeWidth?: number
}

/**
 * メインアイコンの右上に小さいバッジアイコンを表示するコンポーネント
 */
export const BadgeIcon = ({
  MainIcon,
  BadgeIcon,
  mainSize = 20,
  badgeSize = 10,
  badgeStrokeWidth = 2.5,
}: BadgeIconProps) => {
  return (
    <div className="relative">
      <MainIcon size={mainSize} />
      <div className="absolute -top-1.5 -right-2.5 bg-primary text-primary-foreground rounded-full p-0.5">
        <BadgeIcon style={{ width: `${badgeSize}px`, height: `${badgeSize}px` }} strokeWidth={badgeStrokeWidth} />
      </div>
    </div>
  )
}
